class MobileNav {
    constructor() {
        this.transitionEndEventName = this.getTransitionEndEventName()
        this.bodyElement = document.querySelector('body')
        this.mobileMenuButton = document.querySelector('#mobile-menu-button')
        this.mobileNavigation = document.querySelector('.mobile-navigation')
        this.checkbox = document.querySelector('#menu-toggle')
        this.navAccordion = document.querySelector('.nav-accordion')

        if(document.querySelector('.main-header.home')){
            this.cta = document.querySelector('.wrm-action')
            this.discoverButton = document.querySelector('.discover-more')
            this.homePage()
        }else{
            this.default()
        }
        
    }
    default(){
        this.mobileMenuButton.addEventListener('click', ()=>{
            this.toggleNav()
        })
    }
    homePage(){
        this.mobileMenuButton.addEventListener('click', ()=>{
            this.toggleNavHome()
        })
        this.cta.addEventListener(this.transitionEndEventName, this.listenerAnimationFunction = ()=>{
            if(this.checkbox.checked){
                this.cta.style.display = 'none'
                this.discoverButton.style.display = 'none'
                this.mobileNavigation.classList.add('active')
            }
        })
        this.navAccordion.addEventListener(this.transitionEndEventName, this.listenerAnimationFunction = ()=>{
            if(!this.checkbox.checked){
                this.cta.style.display = 'flex'
                this.discoverButton.style.display = 'block'
                this.cta.classList.remove('fade-out')
            }
        })
    }
    toggleNav() {
        console.log('Toggle Nav')
        if(this.checkbox.checked){
            console.log('Checked')
            this.mobileNavigation.classList.add('active')
            this.bodyElement.style.overflow = 'hidden'
        }else{
            console.log('Not Checked')
            this.mobileNavigation.classList.remove('active')
            this.bodyElement.style.overflow = 'auto'
        }
    }
    toggleNavHome() {
        console.log('Toggle Nav Home')
        if(this.checkbox.checked){
            console.log('Checked')
            this.cta.classList.add('fade-out')
            this.bodyElement.style.overflow = 'hidden'
        }else{
            console.log('Not Checked')
            this.mobileNavigation.classList.remove('active')
            this.bodyElement.style.overflow = 'auto'
        }
    }
    // For Animation Transitions
    getTransitionEndEventName() {
        var transitions = {
            "transition"      : "transitionend",
            "OTransition"     : "oTransitionEnd",
            "MozTransition"   : "transitionend",
            "WebkitTransition": "webkitTransitionEnd"
        }
        let bodyStyle = document.body.style
        for(let transition in transitions) {
            if(bodyStyle[transition] != undefined) {
                return transitions[transition]
            } 
        }
    }
}
export default MobileNav